import {twMerge} from '../../../common/twMerge';
import {Text} from '../../atoms/Text/Text';
import {CaptionProps, CaptionType} from './CaptionProps.interface';

/**
 * 캡션
 * 피그마 : https://www.figma.com/file/lun1D9CzpkoufkINaOHID1/NEXT_Design_System?node-id=3742-18326&t=YwJZsT04jAFiMrq9-4
 */
export function Caption({
  type,
  label,
  indent,
  boldDetail,
  className,
  showPrefixDot = true,
  ...props
}: CaptionProps) {
  return (
    <div
      className={twMerge(
        'flex items-center',
        indent && 'pl-15px',
        type === CaptionType.StaticTitle &&
          'font-small2-bold text-static-mono-white',
        type === CaptionType.Static && 'font-small2 text-static-mono-white',
        type === CaptionType.Title && 'font-small2-bold text-theme-solid-100',
        type === CaptionType.Normal && 'font-small2 text-theme-solid-60',
        type === CaptionType.NormalBold &&
          'font-small2-bold text-theme-solid-60',
        type === CaptionType.Body && 'font-small1 text-theme-solid-60',
        className
      )}
      {...props}
    >
      {[
        CaptionType.Static,
        CaptionType.Normal,
        CaptionType.NormalBold,
        CaptionType.Body,
      ].includes(type) &&
        showPrefixDot && <Text className="mr-4px">·</Text>}
      <Text>
        {label}
        {boldDetail && <Text className="font-medium1-bold">{boldDetail}</Text>}
      </Text>
    </div>
  );
}
